import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AlertDetailsPage, { getDefaultPageData } from "components/pages/AlertDetailsPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureNotifiAlertSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    let data = getDefaultPageData("1");
    const details = data.notificationDetails.map(info => {
        info.isEnabled = "false";
        info.amount = 0;

        return info;
    }, []);

    data = BCMSStateManagerCRUD.init(data)
    .update([ "notificationDetails" ], details)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AlertDetailsPage data={ data } />
}